import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import styled from "styled-components";
const UserSection = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 20px;
  font-weight: normal;
  font-size: small;
`;

function LoggedUser() {
  const { user } = useAuth0();
  //console.log(user);
  return (
    <>
      <UserSection> {user.email}</UserSection>
    </>
  );
}
export default LoggedUser;
